import {useMemo} from 'react'
import {useIntl} from 'react-intl'
import {useQueryClient} from 'react-query'
import {ColumnInstance, Row, useTable} from 'react-table'
import {toast} from 'react-toastify'
import {KTCardBody, QUERIES} from '../../../../../../_metronic/helpers'
import {Loading} from '../../../../../components/table/loading/Loading'
import {Pagination} from '../../../../../components/table/pagination/Pagination'
import {useQueryResponse} from '../../pendingWorkAuthorization-list/core/QueryResponseProvider'
import {useListView} from '../core/ListViewProvider'
import {useQueryRequest} from '../core/QueryRequestProvider'
import {
  useQueryResponseData,
  useQueryResponseLoading,
  useQueryResponsePagination,
} from '../core/QueryResponseProvider'
import {PendingWorkAuthorization} from '../core/_models'
import {requestMassApproval} from '../core/_requests'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {pendingWorkAuthorizationColumns} from './columns/_columns'

const PendingWorkAuthorizationTable = ({closeModal}: any) => {
  const intl = useIntl()
  const pending_work_authorization = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => pending_work_authorization, [pending_work_authorization])
  const columns = useMemo(() => pendingWorkAuthorizationColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  const {authSelected, setItemIdForUpdate} = useListView()

  const queryClient = useQueryClient()
  const {query} = useQueryResponse()

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_transaction'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<PendingWorkAuthorization>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<PendingWorkAuthorization>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    {intl.formatMessage({id: 'TABLE.NO_RECORDS_FOUND'})}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pagination
        useQueryRequest={useQueryRequest}
        useQueryResponsePagination={useQueryResponsePagination}
        useQueryResponseLoading={useQueryResponseLoading}
      />
      <div className='d-flex align-items-center justify-content-center w-100'>
        <button
          onClick={async () => {
            const {data} = await requestMassApproval(authSelected)

            if (data.error === 1) {
            } else {
              toast.success(intl.formatMessage({id: 'TOAST.SUCCESS.UPDATE'}))
              queryClient.invalidateQueries([`${QUERIES.PENDING_WORK_AUTHORIZATION}-${query}`])
              closeModal(undefined)
            }
          }}
          disabled={authSelected === undefined || authSelected?.length <= 0}
          className='btn btn-lg btn-primary'
        >
          {intl.formatMessage({id: 'FORM.STEP.BUTTON.CONCLUDE'})}
        </button>
      </div>

      {isLoading && <Loading />}
    </KTCardBody>
  )
}

export {PendingWorkAuthorizationTable}
